import { FC } from 'react';
import { Menu } from 'antd';
import sidebarStyle from './Sidebar.style';
import { Flex } from '../Element';
import { useAppSelector } from '../../hooks/ReduxHook';
import useNavigation from '../../hooks/useNavigation';
import useDeviceSize from '../../hooks/useDeviceSize';
import { useTheme } from '../../theme';

type Props = {
  isActive?: boolean;
  isMobile?: boolean;
};

export const Sidebar: FC<Props> = (properties) => {
  const { modules, openModules } = useAppSelector((state) => state.base);
  const { gotoPage } = useNavigation();
  const onClick = (e: any) => gotoPage(e.key);
  const breakpoints = useDeviceSize();

  let theme = useTheme();
  let style = sidebarStyle(theme, breakpoints, properties.isActive);

  return (
    <Flex vertical={true} style={style.sidebar}>
      <Menu
        onClick={onClick}
        mode="inline"
        style={style.sidebarMenu}
        theme="dark"
        items={modules}
        defaultOpenKeys={openModules}
      />
    </Flex>
  );
};

export default Sidebar;
